import Head from "next/head";
import BigBrainScript from "/components/core/head/bigbrain-script";

const isProduction = process.env.NODE_ENV === "production";

const PAGE_TYPE = "external_sync";

const BbVisitorSyncComponent = ({ source }) => {
  return (
    <>
      <Head>
        <BigBrainScript
          isProduction={isProduction}
          pageType={PAGE_TYPE}
          preventPageView={true}
          crossDomain={true}
          emitVisitorId={true}
          emitTargetOrigin={source}
        />
      </Head>
    </>
  );
};

export default BbVisitorSyncComponent;
